import { getScrollbarWidth } from '~scripts/core/helpers';
import { handleRadioSwitcherInit } from '~scripts/components/forms/radios';

const root = document.documentElement;
const body = document.body;

export const modalHelpers = {
  open: function (modal, additionalFormParams) {
    const scrollbarWidth = getScrollbarWidth();

    root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);

    body.classList.add('no-scroll');

    modal.classList.add('modal--open', 'modal--fade-in');

    modal.addEventListener(
      'animationend',
      () => {
        modal.classList.remove('modal--fade-in');
      },
      {
        once: true,
      }
    );

    const openModal = new CustomEvent('open-modal', {
      bubbles: true,
    });

    modal.dispatchEvent(openModal);

    // If modal contains form
    const form = modal.querySelector('form');

    if (form) {
      const formElements = Array.from(form.elements);

      // Focus first form visible element
      if (
        !form.hasAttribute('data-disable-focus-on-modal-open') ||
        !form.getAttribute('data-disable-focus-on-modal-open')
      ) {
        if (formElements) {
          const firstVisibleElement = formElements.find((element) => {
            const tag = element.tagName;
            const type = element.getAttribute('type');
            return (
              tag !== 'FIELDSET' && tag !== 'LEGEND' && type !== 'hidden' && type !== 'checkbox' && type !== 'radio'
            );
          });

          setTimeout(() => {
            firstVisibleElement.focus();
          }, 100); // 1/2 of 200ms modal fade in animation
        }
      }

      // Init radio switchers
      const radioSwitchers = form.querySelectorAll('.js-radio-switcher');

      if (radioSwitchers) {
        radioSwitchers.forEach((switcher) => {
          const caret = switcher.querySelector('.js-radio-switcher-caret');
          const transitionDuration = 100;

          caret.style.opacity = 0;
          caret.style.transition = `opacity ${transitionDuration}ms`;

          setTimeout(() => {
            handleRadioSwitcherInit(switcher);

            caret.style.opacity = 1;

            setTimeout(() => {
              caret.style.removeProperty('transition');
            }, transitionDuration);
          }, 100); // 1/2 of 200ms modal fade in animation
        });
      }

      // Setting additional params
      if (additionalFormParams) {
        Object.entries(additionalFormParams).forEach(([key, value]) => {
          let input = form.querySelector(`input[name='${key}']`);

          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.classList.add('js-additional-form-param');
            form.appendChild(input);
          }
          input.value = value;
        });
      }
    }
  },
  close: function (modal) {
    // Removing additional params
    const form = modal.querySelector('form');

    if (form) {
      const additionalFormParamInputs = form.querySelectorAll('.js-additional-form-param');

      if (additionalFormParamInputs) {
        additionalFormParamInputs.forEach((input) => {
          form.removeChild(input);
        });
      }
    }

    // Closing modal
    modal.classList.add('modal--fade-out');

    setTimeout(() => {
      modal.scrollTop = 0;
    }, 199); // 199 ms refers to `$transitionDurationBase` SCSS variable

    modal.addEventListener(
      'animationend',
      () => {
        modal.classList.remove('modal--open', 'modal--fade-out');

        body.classList.remove('no-scroll');

        root.style.removeProperty('--scrollbar-width');
      },
      {
        once: true,
      }
    );

    const closeModal = new CustomEvent('close-modal', {
      bubbles: true,
    });

    modal.dispatchEvent(closeModal);
  },
};

document.addEventListener('click', (e) => {
  const target = e.target;

  // Modal selector
  let modalSelector;
  if (target.dataset.modal) {
    modalSelector = target.dataset.modal;
  } else {
    modalSelector = target.closest('[data-modal]')?.dataset?.modal;
  }

  // Additional form params
  let additionalFormParams;

  if (target.dataset.additionalFormParams) {
    additionalFormParams = target.dataset.additionalFormParams;
  } else {
    additionalFormParams = target.closest('[data-additional-form-params]')?.dataset?.additionalFormParams;
  }

  if (additionalFormParams) {
    additionalFormParams = JSON.parse(additionalFormParams);
  }

  // Checking modal
  const modal = document.querySelector(modalSelector);
  if (!modal) {
    return;
  }

  e.preventDefault();

  // Opening modal
  modalHelpers.open(modal, additionalFormParams);
});

// Closing modal on `click`
document.addEventListener('click', (e) => {
  const target = e.target;
  const modalCloseSelector = target.classList.contains('js-modal-close') ? target : target.closest('.js-modal-close');

  if (modalCloseSelector) {
    const modal = modalCloseSelector.closest('.modal');
    modalHelpers.close(modal);
  }
});

// Closing modal on `ESC`
window.addEventListener('keyup', (e) => {
  if (e.code === 'Escape') {
    document.querySelectorAll('.modal--open').forEach((modal) => {
      modalHelpers.close(modal);
    });
  }
});
